import { API } from '@Providers';

export default async function (payload: any) {
  const endpoint = '/api/shelter/animal/register-microchip';

  return API({ endpoint, forwardError: true, method: 'post', payload }).then(
    (result: any) => result
  );
}
